import React, { ReactNode } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { ClickAwayListener, createStyles } from "@material-ui/core";
import { Color } from "../../theme/color";

type Props = {
  clickAway: () => void;
  entries: { text: string; icon: ReactNode; action: () => void; disabled?: boolean }[];
  marginTop?: number;
};

export function MoreList(props: Props) {
  const classes = useStyles({ marginTop: props.marginTop });

  return (
    <ClickAwayListener onClickAway={props.clickAway}>
      <div className={classes.root}>
        <List component="nav">
          {props.entries.map((entry, index) => (
            <ListItem
              button
              key={index}
              onClick={entry.action}
              disabled={!!entry.disabled}
            >
              <ListItemIcon>{entry.icon}</ListItemIcon>
              <ListItemText
                primary={entry.text}
                style={{ width: "100%", whiteSpace: "nowrap" }}
              />
            </ListItem>
          ))}
        </List>
      </div>
    </ClickAwayListener>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: { marginTop?: number }) => ({
      zIndex: 1000,
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${Color.LightGray}`,
      position: "absolute",
      marginTop: props.marginTop || 20,
      right: 0,
      boxShadow: "1px 6px 24px 0px rgba(128, 128, 128, 0.15)"
    })
  })
);
